/**
 * [ellipsisStr 对字符串进行规定长度的省略，超出的部分显示为省略号]
 * @param  {[type]} str [字符串]
 * @param  {[type]} len [规定长度]
 * @return {[type]}     [description]
 */
export function ellipsisStr(str, len) {
    if (len === void 0) { len = 100; }
    if (typeof str !== 'string') {
        return str;
    }
    if (!isNaN(len) && len > 0) {
        str = str.length > len ? (str.substring(0, len) + '...') : str;
    }
    return str;
}
/**
 * @description: 检查文本是否颜色值
 * @param {*} value 文本，rgb(xxx, xxx, xxx)，#fff
 * @return {*}
 */
export function checkIsColor(value) {
    var regStr = '';
    if (/^rgb\(/.test(value)) {
        // 如果是rgb开头，200-249，250-255，0-199
        regStr = '^[rR][gG][Bb][\(]([\\s]*(2[0-4][0-9]|25[0-5]|[01]?[0-9][0-9]?)[\\s]*,){2}[\\s]*(2[0-4]\\d|25[0-5]|[01]?\\d\\d?)[\\s]*[\)]{1}$';
    }
    else if (/^rgba\(/.test(value)) {
        // 如果是rgba开头，判断0-255:200-249，250-255，0-199 判断0-1：0 1 1.0 0.0-0.9
        regStr = '^[rR][gG][Bb][Aa][\(]([\\s]*(2[0-4][0-9]|25[0-5]|[01]?[0-9][0-9]?)[\\s]*,){3}[\\s]*(1|1.0|0|0.[0-9])[\\s]*[\)]{1}$';
    }
    else if (/^#/.test(value)) {
        // 六位或者三位
        regStr = '^#([0-9a-fA-F]{6}|[0-9a-fA-F]{3})$';
    }
    else if (/^hsl\(/.test(value)) {
        // 判断0-360 判断0-100%(0可以没有百分号)
        regStr = '^[hH][Ss][Ll][\(]([\\s]*(2[0-9][0-9]|360｜3[0-5][0-9]|[01]?[0-9][0-9]?)[\\s]*,)([\\s]*((100|[0-9][0-9]?)%|0)[\\s]*,)([\\s]*((100|[0-9][0-9]?)%|0)[\\s]*)[\)]$';
    }
    else if (/^hsla\(/.test(value)) {
        regStr = '^[hH][Ss][Ll][Aa][\(]([\\s]*(2[0-9][0-9]|360｜3[0-5][0-9]|[01]?[0-9][0-9]?)[\\s]*,)([\\s]*((100|[0-9][0-9]?)%|0)[\\s]*,){2}([\\s]*(1|1.0|0|0.[0-9])[\\s]*)[\)]$';
    }
    if (!regStr) {
        return false;
    }
    var reg = new RegExp(regStr);
    return reg.test(value);
}
